module.exports = __webpack_public_path__ + "img/filter.3663e0f8.svg";